import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip as ANTDTooltip } from 'antd';
import { useTheme } from '../../providers';
export function Tooltip({ text, children, position, showArrow = true, visible, }) {
    const theme = useTheme();
    return (_jsx(ANTDTooltip, { title: visible ? text : undefined, placement: position, arrow: showArrow, color: theme.Components.Tooltip.Color.Background, overlayInnerStyle: {
            fontFamily: theme.Typography.FontFamily,
        }, children: children }));
}
//# sourceMappingURL=Tooltip.js.map